import { Validators } from '@angular/forms';

export class SolicitorBorrowerDetailsModel {
  solicitorBorrower = {
    value: null,
    validation: Validators.compose([
      Validators.required,
    ])
  };
  solicitorContact = {
    value: null,
    validation: Validators.compose([
      // Validators.required,
    ])
  };
  solicitorPhone = {
    value: null,
    validation: Validators.compose([
      // Validators.required,
    ])
  };
  solicitorEmail = {
    value: null,
    validation: Validators.compose([
      // Validators.required,
    ])
  };
}
